import { AppBar } from '@mui/material';
import Input from '@mui/material/InputBase';
import { styled as muiStyled } from '@mui/material/styles';
import styled from 'styled-components';

import HelpLink from 'components/b2c/HelpLink';
import { colorUsage, getSpacing, APP_BAR_HEIGHT_IN_PX, fontWeight } from 'stylesheetB2c';

export const BamLogoAppBarContainer = muiStyled(AppBar)(() => ({
  height: `${APP_BAR_HEIGHT_IN_PX}px`,
  boxSizing: 'border-box',
  alignItems: 'center',
  justifyContent: 'center',
  borderBottom: `solid ${colorUsage.bottomLineLogoAppBar} 1px`,
  zIndex: 1,
}));

export const StyledHelpLink = styled(HelpLink)`
  position: absolute;
  right: ${getSpacing(3)};
  top: 50%;
  transform: translateY(-50%);
`;
StyledHelpLink.displayName = 'StyledHelpLink';

export const SearchBar = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 0 ${getSpacing(5)};
`;
SearchBar.displayName = 'SearchBar';

export const SearchInput = muiStyled(Input)(() => ({
  width: '100%',
  height: getSpacing(5),
  padding: `0 ${getSpacing(1)}`,
  backgroundColor: colorUsage.whiteInputBackground,
  color: colorUsage.whiteInputText,
  borderRadius: getSpacing(2),
  fontWeight: fontWeight.normal,
  border: 'none',
  '&::placeholder': { color: colorUsage.whiteInputText },
  '&.MuiInput-input': { padding: 0, '&::placeholder': { opacity: 1 } },
}));
